import React, { useContext, useEffect, createContext } from 'react';
import { useImmer } from 'use-immer';

let initialState = {
  duration: 60,
  win: true,
  pala: {},
  level: 5, // TODO DYNAMIC
  mvp: false,
  courtSide: 'left',
  players: [
    {
      id: 1,
      level: 'same',
      power: 100,
      position: 'left',
      team: true,
      you: true,
    },
    {
      id: 2,
      level: 'same',
      power: 100,
      position: 'right',
      team: true,
      you: false,
    },
    {
      id: 3,
      level: 'same',
      power: 100,
      position: 'right',
      team: false,
      you: false,
    },
    {
      id: 4,
      level: 'same',
      power: 100,
      position: 'left',
      team: false,
      you: false,
    },
  ],
};
const CustomizerContext = createContext();

const CustomizerProvider = ({ children }) => {
  const [state, updateState] = useImmer(initialState);

  // useEffect(() => {
  //   console.log(state);
  // }, [state]);

  const updateSlice = (key, val) => {
    updateState(draft => {
      draft[key] = val;
    });
  };

  const updatePlayers = (id, key, val) => {
    updateState(draft => {
      draft.players[draft.players.findIndex(player => player.id === id)][
        key
      ] = val;
    });
  };

  const shuffle = (from, to) => {
    updateState(draft => {
      let position_a = draft.players[from].position;
      let position_b = draft.players[to].position;
      let results = draft.players.slice();
      let firstItem = draft.players[from];
      draft.players[from].position = position_b;
      results[from] = draft.players[to];
      draft.players[to].position = position_a;
      results[to] = firstItem;
      draft.players = results;
    });
  };

  const erase = id => {
    updateState(draft => {
      draft.players.splice(
        draft.players.findIndex(player => player.id === id),
        1,
      );
    });
  };

  const api = _ => {
    return {
      erase,
      shuffle,
      updateSlice,
      updatePlayers,
    };
  };
  return (
    <CustomizerContext.Provider
      value={{
        state,
        actions: api(),
      }}
    >
      {children}
    </CustomizerContext.Provider>
  );
};
function useCustomizer() {
  const context = useContext(CustomizerContext);
  if (context === undefined) {
    throw new Error(`useCustomizer must be used within a UserProvider`);
  }
  return context;
}

export { CustomizerProvider, useCustomizer };
